/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react';
import { Box, Stack, Paper, MenuItem } from '@mui/material';
import { useApi } from '../../../hooks/userApi';
import { useNavigate } from 'react-router-dom';
import { LoadingContext } from '../../../context/Loading/LoadingContext';
import { PaginationComponent } from '../../../components/tables/footerTableAction/footerTableAction-style';
import BtnPesquisa from '../../../components/BtnPesquisa/BtnPesquisa';
import ButtonPrimary from 'components/Buttons/ButtonPrimary/ButtomPrimary.component';
import TableComponente from 'components/tables/TableComponente/TableComponente.component';
import { TSelect } from 'styles/ListaClientes/ListaClientes.style';

const api = useApi();

const TabelaClientes = ({ vendedor, limit, page, setPageTotal, handchanceCliente, like }) => {
  const { setLoading, setLoadingMensagem, setLoadingBtn }: any = useContext(LoadingContext);
  const [clientes, setClientes] = useState([]);

  useEffect(() => {
    setLoading(true);
    api
      .get('cliente/lead/vendedor/' + vendedor + `?offset=${limit * (page - 1)}&limit=${limit}&like=${like}`)
      .then((r) => {
        if (!r.status) {
          setLoadingMensagem('Erro ao carregar página.');
          setLoadingBtn('OK');
          return;
        }
        setPageTotal(r.page_total);
        setClientes(r.results);
        setLoading(false);
      })
      .catch((e) => {
        const msg = 'Houve um erro interno, tente mais tarde.  (' + e.response.status + ')';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  }, [vendedor, page, like]);

  const handleExcluir = (e: any) => {
    setLoading(true);
    api
      .delete('cliente/' + e)
      .then(() => {
        const msg = 'Lead excluido!';
        setLoadingMensagem(msg);
        setLoadingBtn('OK');
        window.location.reload();
      })
      .catch((err) => {
        const msg = 'Houve um erro interno, tente mais tarde.  (' + err.response.status + ')';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  };

  const headerTable = ['Nome do Lead', 'E-mail', 'Telefone', 'Novo Orçamento', 'Excluir'];

  function formataTable(objeto) {
    const novoObjeto = objeto.map((row) => {
      return {
        rowCell: [
          { campo: row?.nome || '-', onClick: null, link: false },
          { campo: row?.email || '-', onClick: null, link: false },
          { campo: row?.telefone, onClick: null, link: false },
          { campo: '+ Gerar Orçamento', onClick: () => handchanceCliente(row.id), link: true },
          { campo: '- Excluir', onClick: () => handleExcluir(row.id), link: true },
        ],
      };
    });
    return novoObjeto;
  }

  return (
    <>
      <TableComponente table={headerTable} data={formataTable(Object(clientes).length > 0 ? clientes : [])} />
    </>
  );
};

const SelectVendedor = (props) => {
  const { setLoading, setLoadingMensagem, setLoadingBtn }: any = useContext(LoadingContext);
  const [vendedores, setVendedores] = useState([props.user]);

  if (props.user.permissions.includes('Admin')) {
    useEffect(() => {
      setLoading(true);
      api
        .get('vendedor')
        .then((r) => {
          if (!r.status) {
            setLoadingMensagem('Desculpe ocorreu um erro!');
            setLoadingBtn('OK');
            return;
          }
          setLoading(false);
          setVendedores(r.results);
        })
        .catch((e) => {
          const msg = 'Houve um erro interno, tente mais tarde.  (' + e.response.status + ')';

          setLoadingMensagem(msg);
          setLoadingBtn('OK');
        });
    }, []);
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'end !important',
        flexWrap: 'wrap',
        p: 1,
        m: 1,
      }}
    >
      <TSelect
        select
        id="standard-select-currency-native"
        label="Vendedor"
        defaultValue={props.vendedor}
        onChange={props.handleChangeVendedor}
      >
        {vendedores.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.nome}
          </MenuItem>
        ))}
      </TSelect>
    </Box>
  );
};

const Lead = () => {
  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem('user'));
  const [vendedor, setVendedor] = React.useState(user.id);
  const [page, setPage] = useState(1);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [limit, setLimit] = useState(Number(process.env.REACT_APP_PAGINATION_DEFAULT) || 15);
  const [pageTotal, setPageTotal] = useState(0);
  const [like, setLike] = useState('all');

  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handchanceCliente = (id: any) => {
    navigate(`/vendedor/calculoProduto/` + id);
  };

  const handleChangeVendedor = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVendedor(event.target.value);
  };

  const handleNovoCliente = () => {
    navigate('/vendedor/preLead');
  };

  const handleLike = (value) => {
    setPage(1);
    setLike(value);
  };

  return (
    <Stack width="100%">
      <Stack direction="row" flex={1} justifyContent="space-between" width="100%">
        <SelectVendedor
          user={user}
          vendedor={vendedor}
          handleChangeVendedor={handleChangeVendedor}
          handleLike={handleLike}
        />
        <Paper sx={{ margin: '25px' }}>
          <BtnPesquisa handleLike={handleLike} />
        </Paper>
      </Stack>

      <TabelaClientes
        vendedor={vendedor}
        limit={limit}
        page={page}
        setPageTotal={setPageTotal}
        handchanceCliente={handchanceCliente}
        like={like}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          p: 1,
          m: 1,
        }}
      >
        {pageTotal > 1 && (
          <>
            <div>
              Apresentando {page} de {pageTotal} resultados
            </div>
            <PaginationComponent count={pageTotal} page={page} onChange={handleChangePage} />
          </>
        )}
        <ButtonPrimary label={'+ Novo Lead'} typeSubmit={false} onClick={() => handleNovoCliente()} />
      </Box>
    </Stack>
  );
};

export default Lead;
